export type HelpdeskCategoryOption = {
  value: string;
  label: string;
};

export type HelpdeskCategoryGroup = {
  label: string;
  options: HelpdeskCategoryOption[];
};

export const HELP_DESK_CATEGORY_GROUPS: HelpdeskCategoryGroup[] = [
  {
    label: 'Ciberseguridad',
    options: [
      { value: 'Bitdefender Empresas', label: 'Bitdefender Empresas' },
      // Mantener el value histórico para no romper integraciones existentes.
      { value: 'Kapersky Empresas', label: 'Kaspersky Empresas' },
      { value: 'Endpoint Protection', label: 'Endpoint Protection' },
      { value: 'Antispam', label: 'Antispam' },
      { value: 'Seguridad Perimetral', label: 'Seguridad Perimetral' },
      { value: 'Gestión de Vulnerabilidades', label: 'Gestión de Vulnerabilidades' },
    ],
  },
  {
    label: 'Infraestructura TI',
    options: [
      { value: 'Soluciones de Infraestructura', label: 'Soluciones de Infraestructura' },
      { value: 'Soluciones de Networking', label: 'Soluciones de Networking' },
      { value: 'CCTV', label: 'CCTV' },
      { value: 'Hardware', label: 'Hardware' },
      { value: 'Licenciamiento Microsoft', label: 'Licenciamiento Microsoft' },
      { value: 'Gestión de Servicio y Soporte', label: 'Gestión de Servicio y Soporte' },
    ],
  },
  {
    label: 'Soluciones Industriales',
    options: [
      { value: 'Mantenimiento de Equipos Eléctricos', label: 'Mantenimiento de Equipos Eléctricos' },
      { value: 'Instalación de Baterías', label: 'Instalación de Baterías' },
      { value: 'Suministro de Estabilizadores', label: 'Suministro de Estabilizadores' },
      { value: 'Suministro de UPS', label: 'Suministro de UPS' },
      { value: 'Suministro de Transformadores', label: 'Suministro de Transformadores' },
      { value: 'Suministro de Tableros Eléctricos', label: 'Suministro de Tableros Eléctricos' },
      { value: 'Instalación de Pozo a Tierra', label: 'Instalación de Pozo a Tierra' },
    ],
  },
  {
    label: 'Mesa de Ayuda',
    options: [{ value: 'Soporte Help Desk', label: 'Soporte Help Desk' }],
  },
];

